import axios from 'axios';

const API_URL = process.env.VUE_APP_ZHULIA_BASE_URL;

class PipeLineService {
	async getContacts(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.get(
				API_URL + `/Customers/Contacts?Limit=-1`,
				{
					headers: headers,
				}
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getLeads(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.get(API_URL + `/Customers/Leads?Limit=-1`, {
				headers: headers,
			});
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getContactDetailAsync(authToken, id) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.get(API_URL + `/Customers/Contacts/${id}`, {
				headers: headers,
			});

			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getLeadDetailAsync(authToken, id) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.get(API_URL + `/Customers/Leads/${id}`, {
				headers: headers,
			});

			return response;
		} catch (error) {
			return error.response;
		}
	}

	async addContactAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.post(
				API_URL + `/Customers/Contacts`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async addLeadAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.post(
				API_URL + `/Customers/Leads`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async updateleadStatusAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.patch(
				API_URL + `/Customers/Leads/${request_data.id}`,
				request_data.data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}
}

export default new PipeLineService();
